import { motion } from "framer-motion";
import { Overline } from "@/components/motion";
import { DynIcon } from "./iconMap";

export default function WhyVisit({ title, subtitle, items = [] }) {
  return (
    <section id="why-visit" data-testid="why-visit" className="relative py-24 sm:py-32 bg-[#fdfbf7] overflow-hidden">
      <div className="absolute -top-40 -right-40 w-[34rem] h-[34rem] rounded-full bg-[#d4af37]/10 blur-3xl pointer-events-none" />
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <div className="max-w-3xl">
          <Overline>{title || "Why Visit India"}</Overline>
          <h2 className="font-serif text-[#3b1a1a] text-4xl sm:text-6xl leading-[1.03] tracking-tight mt-5">
            One country, <span className="italic text-[#7c1d1d]">a thousand worlds.</span>
          </h2>
          <p className="text-[#5a4b4b] text-lg mt-6 leading-relaxed">
            {subtitle || "No single trip can contain India. Each region is a universe of its own — here are six reasons it will change you."}
          </p>
        </div>

        <div className="mt-16 sm:mt-20 divide-y divide-[#d4af37]/20 border-t border-[#d4af37]/20">
          {items.map((it, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.4 }}
              transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
              className="group grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 items-start py-9 sm:py-12"
            >
              <div className="md:col-span-2 flex items-center gap-4">
                <span className="font-serif text-5xl sm:text-6xl text-[#d4af37]/40 group-hover:text-[#7c1d1d] transition-colors duration-500">
                  {String(i + 1).padStart(2, "0")}
                </span>
              </div>
              <div className="md:col-span-1 flex md:justify-center pt-2">
                <span className="inline-flex items-center justify-center w-12 h-12 border border-[#d4af37]/50 text-[#7c1d1d] group-hover:bg-[#7c1d1d] group-hover:text-white transition-colors duration-500">
                  <DynIcon name={it.icon} className="w-5 h-5" />
                </span>
              </div>
              <h3 className="md:col-span-4 font-serif text-3xl sm:text-4xl text-[#3b1a1a] leading-tight">{it.title}</h3>
              <p className="md:col-span-5 text-[#5a4b4b] text-base sm:text-lg leading-relaxed pt-1">{it.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
